import ActionButton from './ActionButton';
import EstadoActivoPill from './EstadoActivoPill';

const EyeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-3.5 w-3.5">
    <path
      d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

const PencilIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-3.5 w-3.5">
    <path
      d="M12 20h9M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PowerIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-3.5 w-3.5">
    <path
      d="M18.36 6.64a9 9 0 1 1-12.73 0M12 2v10"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function EmptyState() {
  return (
    <tr>
      <td colSpan="4" className="px-4 py-12 text-center text-sm text-white/45">
        No hay conceptos registrados. Crea el primero con el botón superior.
      </td>
    </tr>
  );
}

function LoadingRow() {
  return (
    <tr>
      <td colSpan="4" className="px-4 py-12 text-center">
        <div className="mx-auto h-4 w-32 overflow-hidden rounded-full bg-white/5">
          <div className="h-full w-full animate-shimmer bg-gradient-to-r from-transparent via-white/15 to-transparent bg-[length:200%_100%]" />
        </div>
      </td>
    </tr>
  );
}

function ErrorRow({ message }) {
  return (
    <tr>
      <td colSpan="4" className="px-4 py-12 text-center text-sm text-rose-300/85">
        {message}
      </td>
    </tr>
  );
}

function ConceptoRow({ item, onView, onEdit, onToggle }) {
  const isActive = item.stConcepto === 1;
  const tipoLabel = item.tipoConcepto?.deTipoConcepto ?? '—';
  const tipoAcronym = item.tipoConcepto?.tpConcepto ?? item.tpConcepto ?? '?';
  return (
    <tr className="border-t border-white/5 transition hover:bg-white/[0.02]">
      <td className="px-4 py-4 sm:px-6">
        <span className="inline-flex items-center gap-2 text-sm text-white/85">
          <span className="inline-flex h-6 min-w-6 items-center justify-center rounded-md border border-white/10 bg-white/[0.04] px-1.5 font-mono text-[11px] uppercase tracking-wider text-white/65">
            {tipoAcronym}
          </span>
          {tipoLabel}
        </span>
      </td>
      <td className="px-4 py-4 sm:px-6">
        <span className="text-sm font-medium text-white/90">{item.deConcepto}</span>
      </td>
      <td className="px-4 py-4 sm:px-6">
        <EstadoActivoPill status={item.stConcepto} />
      </td>
      <td className="px-4 py-4 sm:px-6">
        <div className="flex items-center justify-end gap-2">
          <ActionButton label="Visualizar" onClick={() => onView(item)} icon={EyeIcon} />
          <ActionButton label="Actualizar" onClick={() => onEdit(item)} icon={PencilIcon} />
          <ActionButton
            label={isActive ? 'Inhabilitar' : 'Habilitar'}
            onClick={() => onToggle(item)}
            icon={PowerIcon}
            tone={isActive ? 'danger' : 'success'}
          />
        </div>
      </td>
    </tr>
  );
}

function ConceptoTable({ items, isLoading, error, onView, onEdit, onToggle }) {
  const showEmpty = !isLoading && !error && items.length === 0;
  return (
    <div className="overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03]">
      <div className="overflow-x-auto">
        <table className="w-full text-left">
          <thead className="bg-white/[0.02] text-[11px] font-mono uppercase tracking-[0.18em] text-white/45">
            <tr>
              <th scope="col" className="px-4 py-4 sm:px-6">Tipo Concepto</th>
              <th scope="col" className="px-4 py-4 sm:px-6">Concepto</th>
              <th scope="col" className="px-4 py-4 sm:px-6">Estatus</th>
              <th scope="col" className="px-4 py-4 text-right sm:px-6">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && <LoadingRow />}
            {error && !isLoading && (
              <ErrorRow message="No se pudo cargar la lista de conceptos." />
            )}
            {showEmpty && <EmptyState />}
            {!isLoading && !error && items.map((item) => (
              <ConceptoRow
                key={item.cdConcepto}
                item={item}
                onView={onView}
                onEdit={onEdit}
                onToggle={onToggle}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ConceptoTable;